















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Project from '@/components/Project.vue'

@Component({
  components: {
    Project
  }
})
export default class Projects extends Vue {
  selectedProject: string = 'Wayward';

  mounted () {
    this.$root.$on('clicked::link', (clk: any) => {
      if (clk.srcElement.parentElement.className === 'projDropdown') {
        this.selectedProject = clk.target.text
      }
    })
  }
}
